import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { memo } from "react";
import ReactModal from "react-modal";

import Button from "components/Button";
import { useGetDeactivations } from "hooks/apis/user";
import format from "lib/format";
import Empty from "components/Empty";

const DeactivationView = ({ id }: { id: number }) => {
  const modal = useModal();
  const { data, isFetching } = useGetDeactivations({ id });

  const closeModal = () => {
    modal.hide();
    modal.reject();
  };

  return (
    <ReactModal
      overlayClassName="overflow-auto flex fixed size-full top-0 left-0 z-30"
      className="bg-[rgba(0,0,0,0.2)] min-w-[1280px] min-h-[720px] flex justify-center items-center size-full outline-none"
      isOpen={modal.visible}
      onRequestClose={closeModal}
      onAfterClose={() => {
        modal.remove();
      }}
    >
      <main className="bg-white flex flex-col w-[50rem] h-[37.5rem] p-[1.875rem] pt-[2.5rem] rounded-md">
        <h2 className="text-center font-bold text-24 leading-[1.375rem]">
          누적 정지 내역
        </h2>
        <section className="flex flex-col flex-1 overflow-hidden pt-[2.875rem] gap-[0.625rem]">
          <span className="text-16 text-secondary">
            총 {data?.length ?? 0}건
          </span>
          <div className="flex-1 flex flex-col overflow-hidden">
            <table className="flex flex-col">
              <thead className="block text-16 text-white">
                <tr className="flex w-full">
                  <th className="h-14 flex justify-center items-center w-[5.875rem] bg-secondary rounded-l-md">
                    번호
                  </th>
                  <th className="h-14 flex items-center flex-1 bg-secondary px-5 text-left">
                    정지일
                  </th>
                  <th className="h-14 flex items-center flex-1 bg-secondary px-5 text-left">
                    계정 활성화일
                  </th>
                </tr>
              </thead>
              <tbody className="flex-1 text-center text-secondary font-medium text-16">
                {data?.map((deactivation, index) => (
                  <tr
                    key={deactivation.id}
                    className="flex border-b border-gray"
                  >
                    <td className="h-14 w-[5.875rem] flex justify-center items-center">
                      {data.length - index}
                    </td>
                    <td className="text-[#B4B4B4] h-14 flex flex-1 items-center text-left px-5">
                      {format(deactivation.createdAt, "yyyy/MM/dd HH:mm:ss")}
                    </td>
                    <td className="h-14 flex flex-1 items-center text-left px-5">
                      {format(
                        deactivation.reactivationDate,
                        "yyyy/MM/dd HH:mm:ss",
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Empty
              show={!isFetching && !data?.length}
              message="누적 정지가 없습니다."
            />
          </div>
          <div className="flex justify-end gap-2 !mt-[1.875rem]">
            <Button className="w-[10.688rem]" outline onClick={closeModal}>
              닫기
            </Button>
          </div>
        </section>
      </main>
    </ReactModal>
  );
};

const DeactivationViewModal = NiceModal.create(memo(DeactivationView));
DeactivationViewModal.displayName = "DeactivationViewModal";

export default DeactivationViewModal;
